<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4" label="Provider/Facility" label-align="right" :state="stateForField('businessName')" :invalid-feedback="errorForField('businessName')">
              <b-form-input v-model="payee.businessName"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Tax ID" label-align="right" :state="stateForField('taxId')" :invalid-feedback="errorForField('taxId')">
                <b-form-input :formatter="removeLeadingZeros" v-model="payee.taxId"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="NPI" label-align="right" :state="stateForField('npi')" :invalid-feedback="errorForField('npi')">
                <b-form-input :formatter="removeLeadingZeros" v-model="payee.npi"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'PayeeModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editPayee: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        payee: {},
        isSaving: false,
        searchTerm: '',
        matchedCodes: []
      }
    },

    watch: {
      editPayee (newValue) {
        this.clearAllErrors()
        this.payee = _.clone(newValue)
      }
    },

    computed: {
      title () {
        if (this.payee && this.payee.organizationPayeeId) {
          return 'Edit Participating Provider'
        }

        return 'Create Participating Provider'
      }
    },

    methods: {
      removeLeadingZeros (str) {
        return str.replace(/^0+(?=\d)/, '')
      },

      validate () {
        this.clearAllErrors()

        if (!this.payee.taxId) {
          this.addErrorForField('taxId', 'You must add a Tax ID')
        }

        return !this.hasErrors()
      },

      save () {
        if (this.isSaving) {
          return
        }

        const taxId = this.payee.taxId
        if (this.payee.taxId) {
          this.payee.taxId = taxId.replace(/[^\d]/g, '')
        }

        const npi = this.payee.npi
        if (this.payee.npi) {
          this.payee.npi = npi.replace(/[^\d]/g, '')
        }

        if (!this.validate()) {
          return
        }

        this.clearAllErrors()

        let urlSuffix = ''
        if (this.payee.organizationPayeeId) {
          urlSuffix = '/' + this.payee.organizationPayeeId
        }
        this.isSaving = true
        api.post('/Dashboard/Payee' + urlSuffix, this.payee).then(response => {
          this.$emit('payeeSaved', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to save payee: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>
</style>
